export const IS_ADMIN = 'IS_ADMIN'
export const SET_ACADEMY = 'SET_ACADEMY'
export const SET_ACADEMY_MODAL_VISIBILITY = 'SET_ACADEMY_MODAL_VISIBILITY'
export const SET_USER_DETAILS = 'SET_USER_DETAILS'
export const GET_COURSE_BY_ACADEMY = 'GET_COURSE_BY_ACADEMY'
